import BonConsultation from '@/components/caisse/factures/print-bons/bon-consultation'
import BonAnalyse from '@/components/caisse/factures/print-bons/bon-analyse'
import BonExamen from '@/components/caisse/factures/print-bons/bon-examen'
import BonPdfPrint from '@/components/caisse/factures/print-bons/bon-pdf-print'

export default {
    name: 'print-bons',
    components: {
        BonConsultation, BonAnalyse,
        BonExamen, BonPdfPrint
    },
    props: [],
    data() {
        return {
            tab_to_show: 'consultation',
            print_data: {},
            data_toggler: 0
        }
    },

    computed: {

    },

    mounted() {

    },

    methods: {
        changeTab(tab) {
            this.tab_to_show = tab
        },

        triggerPdfPrint(data) {
            this.print_data = data
            this.data_toggler = (this.data_toggler == 0)?1:0
        }
    }
}